import { render, staticRenderFns } from "./ResizableImageTemplate.vue?vue&type=template&id=31218a82&scoped=true&"
import script from "./ResizableImageTemplate.vue?vue&type=script&lang=js&"
export * from "./ResizableImageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31218a82",
  null
  
)

export default component.exports